import { Static } from '@adaptiva/core/common';
import { IClassNameDisplay, ISummarizable, Summarize } from '@adaptiva/core/summary';
import { EBuiltInIds, EJavaClassNames, ServerObject } from '@adaptiva/data-service';
import { ICustomer } from '../../interfaces';

@Static<ISummarizable>()
export class Customer extends ServerObject implements ICustomer {

	public static override readonly classNameDisplay: IClassNameDisplay = {
		singular: 'Customer',
		plural: 'Customers'
	};

	public static readonly className: string = EJavaClassNames.Customer;

	protected static readonly placeholderPhone: string = '+1 5555555555';

	public override javaClassName: string = EJavaClassNames.Customer;

	@Summarize({
		type: 'string',
		columnDisplay: 'Support Contact Email',
		isHeading: true
	})
	public supportContactEmail: string;

	@Summarize({
		type: 'string',
		columnDisplay: 'Billing Contact Email',
		isHeading: true
	})
	public billingContactEmail: string;

	@Summarize({
		type: 'string',
		columnDisplay: 'Contact Number',
		isHeading: true
	})
	public contactNumber: string;

	@Summarize({
		type: 'string',
		columnDisplay: 'Location',
		isHeading: true
	})
	public location: string;

	constructor(_from?: Partial<ICustomer>) {
		super(_from);

		this.supportContactEmail = this.supportContactEmail || 'support@adaptiva.com';
		this.billingContactEmail = this.billingContactEmail || 'placeholder@example.com';
		this.contactNumber = this.contactNumber || Customer.placeholderPhone;
		this.location = this.location || 'PLACEHOLDER';
		this.parentFolderId = this.parentFolderId || EBuiltInIds.ROOT_FOLDER_CUSTOMER_OBJECT;
	}

}
